import { ComponentPropsWithRef } from "react";

export const FileWavIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    {...props}
  >
    <path
      d="M2.29954 15.7973H1.79963C1.24744 15.7973 0.799805 15.3497 0.799805 14.7975V1.79982C0.799805 1.24763 1.24744 0.799999 1.79963 0.799999H8.88437C9.14935 0.800056 9.40348 0.905302 9.59091 1.09261L13.5049 5.00658C13.6922 5.19402 13.7974 5.44814 13.7975 5.71313V8.79858"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.797 5.79911H9.79767C9.24549 5.79911 8.79785 5.35147 8.79785 4.79929V0.799999"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7969 10.7982V12.4979C13.7969 13.6732 14.1448 14.8221 14.7967 15.8C15.4486 14.8221 15.7965 13.6732 15.7965 12.4979V10.7982"
      stroke="currentColor"
      strokeWidth="0.999822"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.79883 10.7982V12.1426C3.79893 12.9057 3.94462 13.6618 4.22809 14.3703L4.79865 15.7973L5.79847 12.298L6.79829 15.7973L7.36886 14.3703C7.65261 13.6619 7.79831 12.9058 7.79812 12.1426V10.7982"
      stroke="currentColor"
      strokeWidth="0.999822"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.79785 15.7973V11.798C9.79785 11.2459 10.2455 10.7982 10.7977 10.7982C11.3499 10.7982 11.7975 11.2459 11.7975 11.798V15.7973"
      stroke="currentColor"
      strokeWidth="0.999822"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.79785 13.7977H11.7975"
      stroke="currentColor"
      strokeWidth="0.999822"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
